import { render, staticRenderFns } from "./candidate-profile-list.vue?vue&type=template&id=3b82d4f3&"
import script from "./candidate-profile-list.vue?vue&type=script&lang=js&"
export * from "./candidate-profile-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports